// extracted by mini-css-extract-plugin
module.exports = {"checkboxInputRow":"k_n4","checkboxInputColumn":"k_n5","inputOptionRow":"k_nK","inputOptionColumn":"k_nL"};